import ExecutivesChangesStatisticsReducer from './ExecutivesChangesStatisticsReducer';

export default from './ExecutivesChangesStatisticsContainer';
export const ExecutivesChangesStatisticsReducers = {
  ExecutivesChangesStatisticsReducer,
};
